import { Button, Stack, TextInput } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

const schema = Yup.object().shape({
  userName: Yup.string().required("نام کاربری اجباری می باشد"),
  password: Yup.string().required("کلمه عبور اجباری می باشد"),
});

function LoginWithPassWord() {
  const { t } = useTranslation();

  const form = useForm({
    initialValues: { phoneNumber: "" },
    validate: yupResolver(schema),
  });
  return (
    <Stack px={20}>
      <form onSubmit={form.onSubmit(console.log)} className="w-100">
        <Stack>
          <TextInput
            label={t("userName")}
            withAsterisk
            size="md"
            placeholder=""
            {...form.getInputProps("userName")}
          />
          <TextInput
            label={t("password")}
            withAsterisk
            size="md"
            type="password"
            {...form.getInputProps("password")}
          />
          <Button type="submit" size="md" mt="lg" className="w-100">
            {t("login")}
          </Button>
        </Stack>
      </form>
    </Stack>
  );
}

export default LoginWithPassWord;
